import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  radioAnatomy.keys,
);

const baseStyle = definePartsStyle({
  control: {
    '&[data-checked]': {
      'bg': 'secondary',
      'borderColor': 'secondary',
      '&:hover': {
        bg: 'secondary',
        borderColor: 'secondary',
      },
    },
  },
  label: {
    width: 'full',
  },
});

const solid = definePartsStyle({
  label: {
    lineHeight: 1,
    width: 'full',
  },
  control: {
    marginBottom: '1',
  },
  container: {
    background: 'gray.50',
    padding: '4',
    alignItems: 'flex-start',
  },
});

const answer = definePartsStyle({
  label: {
    lineHeight: 1,
    width: 'full',
  },
  container: {
    'borderColor': 'gray.200',
    'borderWidth': '1px',
    'borderStyle': 'solid',
    'borderRadius': '5px',
    'padding': '3',
    'alignItems': 'flex-start',
    '&[data-checked]': {
      bg: 'gray.50',
      borderColor: 'gray.400',
    },
  },
});

export const radioTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    solid,
    answer,
  },
});
